import { Component, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { AuthService } from 'src/app/core/services/auth.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { PlanService } from 'src/app/core/services/plan.service';
import { ShellService } from 'src/app/core/services/shell.service';
import { StateManagementStorageService } from 'src/app/core/services/state-management-storage.service';
import { UserService } from 'src/app/core/services/user.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';
import { UserRoleService } from 'src/app/core/services/user-role.service';
import moment from 'moment';
import { BsModalRef } from 'ngx-bootstrap';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AppErrorHandler } from 'src/app/core/services/app-error-handler.service';

interface Company {
    companyId?: number;
    companyName: string;
    companyType: string;
    companyState?: string;
    companyStateLabel?: string;
    vendor?: boolean;
}

@Component({
    selector: 'app-companies',
    templateUrl: './companies.component.html'
})
export class CompaniesComponent implements OnInit {

    companies: Company[] = [];
    hostCompanies: Company[] = [];
    staffingCompanies: Company[] = [];
    corporationCompanies: Company[] = [];
    searchTerm: { companyName: string } = { companyName: '' };
    showLogoutButtonInPopup = false;
    companyListLoaded = false;
    hasError = false;
    disableLogoutButton = true;
    isSuperUser = false;
    isFourDotFiveAdmin = false;

    constructor(
        private companyService: CompanyService,
        private storageService: StorageService,
        public authService: AuthService,
        private planService: PlanService,
        private utilityService: UtilityService,
        private stateManagementStorageService: StateManagementStorageService,
        private userService: UserService,
        private userRoleService: UserRoleService,
        private $state: StateService,
        public bsModalRef: BsModalRef,
        private alertAndNotificationService: AlertAndNotificationsService,
        private appErrorHandler: AppErrorHandler,
        private shellService: ShellService
    ) { }

    ngOnInit(): void {
        const user = this.authService.getUserDetails();
        const roleName = user && user.roleScreenRef && user.roleScreenRef.role && user.roleScreenRef.role.name;
        this.isSuperUser = roleName === MESSAGECONSTANTS.ROLES.SUPERUSER;
        this.isFourDotFiveAdmin = roleName === MESSAGECONSTANTS.ROLES.FOURDOTFIVEADMIN;
        this.getAllCompanies();
    }

    getAllCompanies(): void {
        this.companyService.getAllCompanies((data: Company[]) => {
            this.companies = [];
            if (!data || data.length === 0) {
                this.showLogoutButtonInPopup = true;
            }
            (data || []).forEach((company) => {
                if (!this._checkCompanyExists(company)) {
                    company.companyStateLabel = company.companyState === 'SoftHold' ? 'Soft Hold' : company.companyState;
                    this.companies.push(company);
                }
            });

            this.hostCompanies = this.companies.filter(company => company.companyType === 'Host');
            this.staffingCompanies = this.companies.filter(company => company.companyType === 'StaffingCompany');
            this.corporationCompanies = this.companies.filter(company => company.companyType === 'Corporation');

            this.companyListLoaded = true;
            setTimeout(() => {
                this.disableLogoutButton = false;
            }, 2000);
        },
            (error: any) => {
                this.hasError = true;
                this.alertAndNotificationService.showBannerMessage(error.message, 'danger');
            }
        );
    }

    getCompany(company: Company): void {
        this.searchTerm.companyName = '';
        this.companyService.companyDeletedShowPopup = false;
        this.companyService.selectedCompanyId = company.companyId;
        this.shellService.showNotificationsIcon = false;

        if (company.companyType === 'Host') {
            this.storageService.set('SelectedHostCompany', company, null);
        } else {
            this.storageService.set('companyDetails', company, null);
        }

        this.authService.userDetails.company.companyId = company.companyId;
        this.authService.userDetails.company.companyName = company.companyName;
        this.authService.userDetails.company.companyType = company.companyType;
        this.authService.userDetails.company.companyState = company.companyState;
        this.companyService.setCompanyStateLabel();
        this.stateManagementStorageService.clearStatesOfScreens();
        this.authService.userDetails.company.companySelected = true;
        this.authService.notifyUserDetailsChanged();
        this.getPlan(company.companyId);
    }

    getPlan(companyId) {
        this.utilityService.showLoadingModal('Loading...');

        this.planService.getCurrentPlan(companyId, (data: any) => {
            if (data) {
                this.authService.userDetails.plan.planName = data.planHeaderDto.planName;
                this.authService.userDetails.plan.startDate = moment(data.planHeaderDto.planStartDate);
                this.authService.userDetails.plan.endDate = moment(data.planHeaderDto.planEndDate);
                this.authService.userDetails.plan.planType = data.planHeaderDto.planType;
                this.authService.notifyUserDetailsChanged();
            }
            this.storageService.set(
                'userDetails',
                this.authService.userDetails,
                { expires: new Date(Date.now() + this.authService.tokenvalidity) }
            );
            this.authService.setIsSwitchClicked(false);
            this.destroyModal();
            setTimeout(() => {
                if (this.authService.userDetails.roleScreenRef.role.name === '4dot5SuperUser'
                    && this.authService.userDetails.company.companyType === 'Host') {
                    this.$state.go(
                        'missioncontrol.companymanagement',
                        { selectedCompanyId: companyId, vendorId: null, clientOrBuObject: null },
                        { reload: true }
                    );
                } else if (this.storageService.get('companyDetails') != null
                    && this.authService.userDetails.company.companyState === 'Active') {
                    if (this.authService.userDetails.plan.planName !== 'Vendor Only') {
                        this.$state.go('missioncontrol.dashboard', null, { reload: true });
                    } else {
                        this.$state.go('missioncontrol.requisitions', null, { reload: true });
                    }
                } else {
                    this.$state.go(
                        'missioncontrol.companymanagement',
                        { clientOrBuObject: null, vendorId: null },
                        { reload: true }
                    );
                }
                this.utilityService.hideLoadingModal();
                const cacheObj = {
                    userId: this.authService.userDetails.id,
                    loggedInCompanyId: this.authService.userDetails.company.companyId
                };
                this.userService.userCache(cacheObj, () => { }, (err: any) => console.log(err));
            }, 500);
            this.shellService.showNotificationsIcon = true;
        },
            (error: any) => {
                this.appErrorHandler.throwError(error);
            }
        );
    }

    addCompany(): void {
        this.destroyModal();
        this.companyService.companyDeletedShowPopup = false;
        this.storageService.remove('companyDetails');
        this.storageService.remove('SelectedHostCompany');
        this.authService.userDetails.company.companyId = null;
        this.authService.userDetails.company.companyName = null;
        this.authService.userDetails.company.companyType = null;
        this.authService.userDetails.company.companyState = 'Draft';
        this.companyService.setCompanyStateLabel();
        this.authService.userDetails.company.companySelected = false;
        this.authService.notifyUserDetailsChanged();
        this.storageService.set(
            'userDetails',
            JSON.parse(JSON.stringify(this.authService.userDetails)),
            { expires: new Date(Date.now() + this.authService.tokenvalidity) }
        );
        this.$state.go('missioncontrol.companymanagement', { companyObject: this.authService.userDetails.company }, { reload: true }).then(() => {
            // The navigation interrupts the modal's close, leaving its scroll lock on the body.
            document.body.classList.remove('modal-open');
            document.body.style.paddingRight = '';
        });
    }

    logoutAsNoCompaniesRelated(): void {
        this.destroyModal();
        setTimeout(() => {
            this.authService.requestLogout();
        }, 200);
    }

    destroyModal(): void {
        this.authService.setIsSwitchClicked(false);
        this.bsModalRef.hide();
    }

    dismissModal(): void {
        this.bsModalRef.hide();
    }

    dismissModalAndDestroy(): void {
        this.authService.setIsSwitchClicked(false);
        this.destroyModal();
    }

    filterCompanies(companies: Company[]): Company[] {
        const searchText = (this.searchTerm && this.searchTerm.companyName ? this.searchTerm.companyName : '').toLowerCase();
        return companies.filter(company => company.companyName && company.companyName.toLowerCase().includes(searchText));
    }

    private _checkCompanyExists(element: Company): boolean {
        return this.companies.some(
            c => c.companyId === element.companyId && c.companyName === element.companyName
        );
    }
}
